const loginConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('login', {
      url: '/login',
      params: {
        obj: null,
      },
      template: '<app-login></app-login>',
      access: {
        loginRequired: false,
      },
      resolve: {
        // used to set the page title
        $title: () => 'Login',
      },
    });
};

export default loginConfig;



// WEBPACK FOOTER //
// ./src/modules/login/login.config.js